/**
 * package: com.inq.ui
 * class: Canvas
 * @extends com.inq.ui.Container 
 * @constructor
 */
com.inq.ui.Canvas = function(_id) {
	com.inq.ui.Container.call(this,_id);
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.Canvas, "com.inq.ui.Canvas");

/**
 * resize
 *
 * $type TFun([],TEnum(Void,[]))
 * public override function resize()
 * @override
 * @public
 * @this com.inq.ui.Canvas
 * @return {void}
 */
com.inq.ui.Canvas.prototype.resize = function() {
	com.inq.ui.Container.prototype.resize.call(this);/*  resize this application*/
};

com.inq.ui.Canvas.prototype.applySkinAttribute = function() {
	var accesskey = this.getStyle("accesskey");
	if(null != accesskey) {
		this._div.setAttribute("accesskey", accesskey)
	}
	var tabindex = this.getStyle("tabindex");
	if(null != tabindex) {
		this._div.setAttribute("tabindex", tabindex)
	}
	if(this.getStyle("nativescroll") != null) {
		this.scroller = new com.inq.ui.NativeScroller(this._div, true);
	}
};

com.inq.ui.Canvas.prototype.applyStyle = function (){
	com.inq.ui.Container.prototype.applyStyle.call(this);
	if (this.scroller) {
		this.scroller.applyOverflowStyle();
	}
};

/**
 *  encapsulating the removeAttribute to canvas class
 *  @param {String} attr
 *  @return {void}
 */
com.inq.ui.Canvas.prototype.removeAttribute = function(attr)
{
	if(this._div)
		this._div.removeAttribute(attr);
};

com.inq.ui.Canvas.prototype.cleanUp = function () {
	if (this.scroller) {
		this.scroller.cleanUp();
	}
};
/** @type {com.inq.ui.Canvas} */
com.inq.ui.Canvas.prototype.__class__ = com.inq.ui.Canvas;
